<div class="lu-switch">
	<div class="lu-switch-wrap">
		<span
			class="switch-label falsy"
			[ngClass]="{ 'switch-label--active': !value, 'switch-label--disabled': options.disabled }"
			*ngIf="!!options.falsyText"
			(click)="toggle($event, false)"
			>{{ options.falsyText }}</span
		>
		<div
			class="switch"
			[ngClass]="{ 'switch--checked': value, 'switch--disabled': options.disabled }"
			(click)="toggle($event, null)"
			(keydown.space)="toggle($event, null)"
			(keydown.enter)="toggle($event, null)"
			role="checkbox"
			tabindex="0"
			[attr.aria-checked]="value"
			[attr.aria-disabled]="options.disabled"
			[attr.aria-label]="ariaInfo">
			<small class="switch__circle"></small>
		</div>
		<span
			class="switch-label truthy"
			*ngIf="!!options.truthyText"
			(click)="toggle($event, true)"
			[ngClass]="{ 'switch-label--active': value, 'switch-label--disabled': options.disabled }"
			>{{ options.truthyText }}</span
		>
		<span
			class="switch-info"
			*ngIf="!!options.tooltipMessage"
			#switchInfo
			tabindex="0"
			role="button"
			[title]="'lup.a11y.info_tab' | translate"
			(keydown.space)="openTooltip($event)"
			(keydown.enter)="openTooltip($event)"
			(click)="openTooltip($event)">
			<lu-icon icon="info-circle"></lu-icon>
		</span>
	</div>
</div>
